// src/api/features/account/queries.ts
import {
  useQuery,  
  useQueryClient,
  type QueryKey,
} from "@tanstack/react-query";

import { getMyAccount } from "./api";
import { AccountKeys } from "./types";

/* =========================
 * React Query Hooks
 * ========================= */

/**
 * 🔹 Fetch the logged-in user's own account/profile.
 *
 * Backend side:
 * - Resolves user from auth token/session.
 * - Returns MyAccountResult.
 */
export function useMyAccount() {
  const key: QueryKey = AccountKeys.me;

  return useQuery({
    queryKey: key,
    queryFn: () => getMyAccount(),
    staleTime: 60_000,
    gcTime: 10 * 60_000,
  });
}

/* =========================
 * Prefetch helper (optional)
 * ========================= */

export function prefetchMyAccount(
  qc: ReturnType<typeof useQueryClient>
): Promise<void> {
  return qc.prefetchQuery({
    queryKey: AccountKeys.me,
    queryFn: () => getMyAccount(),
    staleTime: 60_000,
  }) as Promise<void>;
}
